// API Configuration Constants
export const API_ENDPOINTS = {
  CUSTOMERS: {
    SINGLE: (id: string) => `/api/v1/company/quickbooks-online/reconciliation/dev/customers/${id}`,
    LIST: '/api/v1/company/quickbooks-online/reconciliation/dev/customers'
  },
  INVOICES: {
    SINGLE: (id: string) => `/api/v1/company/quickbooks-online/reconciliation/dev/invoices/${id}`,
    LIST: '/api/v1/company/quickbooks-online/reconciliation/dev/invoices'
  },
  LOCAL_SUMMARY: '/api/v1/company/quickbooks-online/reconciliation/local-summary',
  DEV_COUNTS: '/api/v1/company/quickbooks-online/reconciliation/dev/counts',
  FIX_QBO: (type: string, id: string) => `/api/v1/company/quickbooks-online/reconciliation/dev/fix-qbo/${type}/${id}`
} as const;

// Type-safe endpoint getters
export const getApiEndpoint = (type: 'customer' | 'invoice', action: 'single' | 'list', id?: string) => {
  console.log('🔍 getApiEndpoint called with:', { type, action, id });
  
  // Map singular types to plural API endpoint keys
  const typeMapping = {
    'customer': 'CUSTOMERS',
    'invoice': 'INVOICES'
  } as const;
  
  const endpointKey = typeMapping[type];
  const endpointConfig = API_ENDPOINTS[endpointKey];
  console.log('🔍 endpointKey:', endpointKey, 'endpointConfig:', endpointConfig);
  
  if (!endpointConfig) {
    throw new Error(`No endpoint configuration found for type: ${type} (mapped to: ${endpointKey})`);
  }
  
  if (action === 'single' && id) {
    const endpoint = (endpointConfig as any).SINGLE(id);
    console.log('🔍 single endpoint:', endpoint);
    return endpoint;
  } else if (action === 'list') {
    const endpoint = (endpointConfig as any).LIST;
    console.log('🔍 list endpoint:', endpoint);
    return endpoint;
  }
  
  throw new Error(`Invalid endpoint configuration for ${type}:${action}`);
};

// Lookup Type Configuration
export const LOOKUP_CONFIGS = {
  customer: {
    placeholder: 'Enter Customer ID',
    buttonColor: 'bg-purple-600 hover:bg-purple-700',
    borderColor: 'border-purple-600',
    textColor: 'text-purple-600',
    label: 'Customer Lookup',
    dataKey: 'customers' as const
  },
  invoice: {
    placeholder: 'Enter Invoice ID',
    buttonColor: 'bg-blue-600 hover:bg-blue-700',
    borderColor: 'border-blue-600',
    textColor: 'text-blue-600',
    label: 'Invoice Lookup',
    dataKey: 'invoices' as const
  },
  payment: {
    placeholder: 'Enter Payment ID',
    buttonColor: 'bg-green-600 hover:bg-green-700',
    borderColor: 'border-green-600',
    textColor: 'text-green-600',
    label: 'Payment Lookup',
    dataKey: 'items' as const
  }
} as const;

// API Parameters
export const API_PARAMS = {
  DEFAULT_PAGINATION: { page: 1, pageSize: 1, search: '' }
} as const;

// UI Constants
export const UI_CONSTANTS = {
  INPUT_WIDTH: 'w-32',
  MAX_DATA_WIDTH: 'max-w-64',
  STATUS_COLORS: {
    success: 'bg-green-100 text-green-800',
    error: 'bg-red-100 text-red-800',
    loading: 'bg-yellow-100 text-yellow-800',
    ready: 'bg-gray-100 text-gray-800'
  },
  STATUS_ICONS: {
    success: '✅',
    error: '❌',
    loading: '⏳',
    ready: '⏸️'
  }
} as const;
